export default __webpack_public_path__ + "static/media/tms-motor.1089fbf2.pdf";